require('./bootstrap');
window.$ = window.jQuery = require('jquery');
require('./ajax_web.js');
require('./custom_web.js');
require('./indexeddb-products.js');

import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

document.addEventListener('DOMContentLoaded', function () {
    const carousel = document.getElementById('carouselHome');

    if (!carousel) return;

    function animateActiveSlide() {
        const activeSlide = carousel.querySelector('.carousel-item.active');
        const title = activeSlide.querySelector('.slide-title');
        const text = activeSlide.querySelector('.slide-text');
        const button = activeSlide.querySelector('.btn-slider');
        const folky = activeSlide.querySelector('.folky');

        if (title) {
            gsap.fromTo(title,
                { opacity: 0, y: 30 },
                { opacity: 1, y: 0, duration: 1, ease: "power2.out" }
            );
        }

        if (text) {
            gsap.set(text, { opacity: 0, y: 50 });
            gsap.to(text, {
                opacity: 1,
                y: 0,
                duration: 1,
                delay: 0.3,
                ease: "power2.out"
            });
        }

        if (button) {
            gsap.set(button, { opacity: 0, y: 50 });
            gsap.to(button, {
                opacity: 1,
                y: 0,
                duration: 1,
                delay: 0.3,
                ease: "power2.out"
            });
        }

        if (folky) {
            gsap.fromTo(folky,
                { x: 100, opacity: 0 },
                { x: 0, opacity: 1, duration: 0.8, delay: 0.6, ease: "back.out(1.7)" }
            );
        }
    }

    // Ejecutar animación cuando cambia de slide
    carousel.addEventListener('slid.bs.carousel', animateActiveSlide);

    function animateOnScroll() {
        gsap.utils.toArray('.fade-up').forEach(el => {
            gsap.from(el, {
                scrollTrigger: {
                    trigger: el,
                    start: "top 85%",
                    toggleActions: "play none none none",
                },
                y: 50,
                opacity: 0,
                duration: 1,
                ease: "power2.out"
            });
        });

        gsap.utils.toArray('.fade-left').forEach(el => {
            gsap.from(el, {
                scrollTrigger: {
                    trigger: el,
                    start: "top 85%",
                    toggleActions: "play none none none",
                    once: true,
                },
                x: -50,
                opacity: 0,
                duration: 1,
                ease: "power2.out"
            });
        });

        gsap.utils.toArray('.fade-right').forEach(el => {
            gsap.from(el, {
                scrollTrigger: {
                    trigger: el,
                    start: "top 85%",
                    toggleActions: "play none none none",
                    once: true,
                },
                x: 50,
                opacity: 0,
                duration: 1,
                ease: "power2.out"
            });
        });
    }

    // Ejecutar animación inicial al cargar
    animateActiveSlide();
    animateOnScroll();
});

function toggleFixedPosition(elementId) {
    const header = document.querySelector('header');
    const element = document.getElementById(elementId);
    if (!element) return;

    const scrollTop = window.scrollY;
    const isScrolled = scrollTop > header.offsetHeight;

    element.classList.toggle('fixed', isScrolled);
    element.classList.toggle('absolute', !isScrolled);
}

function handleScroll() {
    toggleFixedPosition('sidebar');
    toggleFixedPosition('filtersMobile');
    toggleFixedPosition('mobile-menu');
}

// Scroll general
document.addEventListener('scroll', handleScroll);

// Eventos personalizados
window.addEventListener('reloadPage', () => location.reload());
window.addEventListener('sidebar-toggled', () => toggleFixedPosition('sidebar'));
window.addEventListener('filters-toggled', () => toggleFixedPosition('filtersMobile'));
window.addEventListener('menuMobile-toggled', () => toggleFixedPosition('mobile-menu'));

// Lazy loading de imágenes - versión simple
const loadVisibleImages = () => {
    const lazyImages = document.querySelectorAll('img.lazy[data-src]');
    let loadedCount = 0;
    let visibleCount = 0;

    lazyImages.forEach(img => {
        if (!img.dataset.src) return; // Ya fue cargada

        // Remover d-none temporalmente para obtener posición real
        const hadDNone = img.classList.contains('d-none');
        if (hadDNone) img.classList.remove('d-none');

        const rect = img.getBoundingClientRect();
        const isVisible = (
            rect.top < window.innerHeight + 200 &&
            rect.bottom > -200 &&
            rect.left < window.innerWidth + 200 &&
            rect.right > -200
        );

        if (isVisible) {
            visibleCount++;
            img.src = img.dataset.src;
            img.removeAttribute('data-src');
            loadedCount++;
        } else if (hadDNone) {
            img.classList.add('d-none'); // Devolver si no es visible
        }
    });
};

const initLazyLoading = () => {
    const lazyImages = document.querySelectorAll('img.lazy[data-src]');
    loadVisibleImages();
};

// Usar MutationObserver para detectar cuando se agregan imágenes al DOM
const mutationObserver = new MutationObserver(() => {
    const lazyImages = document.querySelectorAll('img.lazy[data-src]');
    if (lazyImages.length > 0) {
        loadVisibleImages();
    }
});

document.addEventListener('DOMContentLoaded', () => {
    // Iniciar observación del DOM
    mutationObserver.observe(document.body, {
        childList: true,
        subtree: true
    });

    // Inicializar lazy loading
    setTimeout(() => initLazyLoading(), 1500);

    // Cargar imágenes cuando se scrollea
    let scrollTimeout;
    document.addEventListener('scroll', () => {
        clearTimeout(scrollTimeout);
        scrollTimeout = setTimeout(() => loadVisibleImages(), 100);
    }, { passive: true });
});
